import { createAction } from '@reduxjs/toolkit';

import { GenericPayloadType } from '../../../../../packages/types/src';

export const myBetsActions = {
  myBets: {
    cache: createAction('myBets/cache'),
    compute: createAction('myBets/compute'),
    push: createAction<GenericPayloadType>('myBets/push'),
    pop: createAction('myBets/pop'),
    clear: createAction('myBets/clear'),
  },
};
